module.exports = __webpack_public_path__ + "static/banner-tv-strass-base-conica-c8da6c6ed5c2612be1607bebe04a874d.jpg";